import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Come fate ad arrivare davvero in 90 minuti col traffico di Napoli?",
    a: "Semplice: non usiamo il furgone. I nostri tecnici si muovono solo in scooter con zaino attrezzato, tagliano i vicoli e non perdono tempo a cercare parcheggio. Abbiamo unità dislocate tra Centro Storico, Vomero, Chiaia e Fuorigrotta, quindi c'è sempre un Mastro vicino a te.",
  },
  {
    q: "Accettate contanti?",
    a: "No, e siamo fieri: solo pagamenti digitali e POS (SumUp, Apple Pay, Satispay, bonifico istantaneo). È più sicuro per te e per il tecnico, e ricevi immediatamente scontrino telematico o fattura via email.",
  },
  {
    q: "Cosa succede se il ricambio non è disponibile subito?",
    a: "Grazie alla pre-diagnosi video, nel 95% dei casi il ricambio giusto è già nello zaino. Se serve un pezzo particolare, mettiamo in sicurezza il guasto, ordiniamo il ricambio e torniamo a completare il lavoro senza un secondo diritto di uscita.",
  },
  {
    q: "Fate fattura per detrazioni o costi aziendali del B&B?",
    a: "Sì, sempre. Ogni intervento è tracciato con scontrino telematico o fattura elettronica, perfetta per detrazioni fiscali, bilanci condominiali e contabilità delle strutture ricettive.",
  },
  {
    q: "Operate anche nei festivi e di sera?",
    a: "Sì. Le emergenze non guardano il calendario: siamo operativi 7 giorni su 7, dalle 8:00 alle 22:00, festivi inclusi. Per i clienti con convenzione B&B e condominio c'è priorità d'uscita anche in fascia serale.",
  },
  {
    q: "Come funziona la convenzione per gestori di case vacanza?",
    a: "Canone zero: paghi solo gli interventi che richiedi. Attiviamo custodia chiavi con codice di sicurezza, corsia preferenziale sulle urgenze e un'unica fattura riepilogativa mensile. Scrivici su WhatsApp con 'Richiedi Convenzione' e ti mandiamo il modulo in 5 minuti.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="bg-[#0A1329] py-16 sm:py-28" data-testid="faq-section">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <p className="font-mono-accent text-xs font-bold uppercase tracking-[0.22em] text-[#FFB800]">
            05 — Domande frequenti
          </p>
          <h2 className="font-display mt-3 text-3xl font-extrabold uppercase tracking-tight sm:text-4xl lg:text-5xl">
            Dubbi? <span className="text-[#FF5500]">Risposte secche.</span>
          </h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
        >
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion-container">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="rounded-xl border border-white/10 bg-[#0D1833] px-5 transition-colors duration-200 data-[state=open]:border-[#FF5500]/45"
              >
                <AccordionTrigger
                  data-testid={`faq-item-trigger-${i + 1}`}
                  className="py-5 text-left font-display text-lg font-bold uppercase tracking-tight text-white hover:no-underline [&[data-state=open]]:text-[#FFB800]"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm leading-relaxed text-slate-400 sm:text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
      <div className="hazard-stripe mt-16 sm:mt-28" />
    </section>
  );
}
